import { topics } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((topic) => {
            const colorClass = topic.color === 'primary'
              ? 'bg-primary-50 text-primary-700 border-primary-200 hover:bg-primary-100'
              : topic.color === 'accent'
                ? 'bg-accent-50 text-accent-700 border-accent-200 hover:bg-accent-100'
                : 'bg-secondary-50 text-secondary-700 border-secondary-200 hover:bg-secondary-100';
            return (
              <a
                key={topic.tag}
                href={topic.href}
                className={`flex items-center gap-2 px-4 py-2 rounded-full border text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap ${colorClass}`}
              >
                <span className="font-label font-medium">{topic.tag}</span>
                <span className="text-xs opacity-60">{topic.heat}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}